//flügeltore
import {fluegeltore_data} from '../../../assets/images/tore/fluegeltore/fluegeltore_data';
//schiebetore
import {schiebetore_data} from '../../../assets/images/tore/schiebetore/schiebetore_data';

const initialeStates = {
    data: [schiebetore_data, fluegeltore_data],
    modell_index: '',
    allVisitedSteps: []
}

const toreReducer = (states = initialeStates, action) => {
    const copyOfState = {...states};

    switch (action.type) {
        //get index of modell
        case 'UPDATEMODELLINDEXTORE':
            copyOfState.modell_index = action.ev;
        return copyOfState;

        //update tab index
        case 'UPDATETABINDEXTORE':
            let tab_index = action.ev;
            copyOfState.data[copyOfState.modell_index].tab_index = tab_index;
        return copyOfState;

        //update muster
        case 'UPDATEMUSTERTORE':
            let muster = action.ev;
            copyOfState.data[copyOfState.modell_index].modell[0].muster = muster;
        return copyOfState;

        //update modell
        case 'UPDATEMODELLTORE':
            let modell_index = action.ev.index;
            let modell_img = action.ev.img;
            let modell_titel = action.ev.titel;
            let modell_form = action.ev.form;

            copyOfState.data[copyOfState.modell_index].modell[0].index = modell_index;
            copyOfState.data[copyOfState.modell_index].modell[0].img = modell_img;
            copyOfState.data[copyOfState.modell_index].modell[0].titel = modell_titel;
            copyOfState.data[copyOfState.modell_index].modell[0].form = modell_form;
        return copyOfState;

        //update steps
        case 'UPDATESTEPSTORE':
            let step_index = action.ev;
            let steps = copyOfState.data[copyOfState.modell_index].steps[0];
            let visited_steps = copyOfState.data[copyOfState.modell_index].steps[1].visited;
            let step_icons = document.querySelectorAll(".MuiStepIcon-root");

            copyOfState.data[copyOfState.modell_index].steps[0][step_index] = true;
            copyOfState.data[copyOfState.modell_index].steps[1].visited[step_index] = step_index;

            steps.forEach((elem, index) => {
                 if(elem === true) {
                    step_icons[index].classList.add('MuiStepIcon-active');
                 } else {
                    step_icons[index].classList.remove('MuiStepIcon-active');
                 }
            })

            copyOfState.allVisitedSteps = visited_steps;
        return copyOfState;

        //update all visited steps
        case 'UPDATEALLVISITEDSTEPSTORE':
            copyOfState.data[copyOfState.modell_index].allVisitedSteps = true;
        return copyOfState;

        //update width
        case 'UPDATEWIDTHTORE':
            let width = action.ev;
            copyOfState.data[copyOfState.modell_index].dimensions[0].width = width;
        return copyOfState;

        //update height
        case 'UPDATEHEIGHTTORE':
            let height = action.ev;
            copyOfState.data[copyOfState.modell_index].dimensions[0].height = height;
        return copyOfState;

        //update form
        case 'UPDATEFORMTORE':
            let form = action.ev;
            copyOfState.data[copyOfState.modell_index].form = form;
        return copyOfState;

        //update kind of color
        case 'SELECTKINDOFCOLORTORE':
            let kind_of_color = action.ev;
            copyOfState.data[copyOfState.modell_index].colors[0].kind_of_color = kind_of_color;
        return copyOfState;

        //update color
        case 'SELECTCOLORTORE':
            let color = action.ev.color;
            let color_index = action.ev.index;
            copyOfState.data[copyOfState.modell_index].colors[0].color_index = color_index;
            copyOfState.data[copyOfState.modell_index].colors[0].color = color;
            copyOfState.data[copyOfState.modell_index].colors[0].wish_color = '';
        return copyOfState;

        //update wish color
        case 'SELECTWISHCOLORTORE':
            let wish_color = action.ev;
            copyOfState.data[copyOfState.modell_index].colors[0].wish_color = wish_color;
        return copyOfState;

        //update Zaunspitze
        case 'UPDATEZAUNSPITZENTORE':
            let spitze = action.ev.titel;
            let spitze_index = action.ev.index;

            copyOfState.data[copyOfState.modell_index].spitzen[0].spitze = spitze;
            copyOfState.data[copyOfState.modell_index].spitzen[0].index = spitze_index;
        return copyOfState;

        //update pfosten
        case 'UPDATEPFOSTENTORE':
            let pfosten_ident_index = action.ev.ident_index;
            let pfosten_ident_name = action.ev.ident_name;
            let pfosten_ident_value = action.ev.value;


             if(pfosten_ident_name === 'pfostenwidth') {
                 copyOfState.data[copyOfState.modell_index].pfosten[0].pfosten_width = pfosten_ident_value;
             }
             if(pfosten_ident_index === '0') {
                 copyOfState.data[copyOfState.modell_index].pfosten[0].ispfosten = true;
                 copyOfState.data[copyOfState.modell_index].pfosten[0].iskappen = false;
             }
             else if(pfosten_ident_index === '1') {
                 copyOfState.data[copyOfState.modell_index].pfosten[0].ispfosten = false;
                 copyOfState.data[copyOfState.modell_index].pfosten[0].iskappen = true;
             }
        return copyOfState;

        //update kappen
        case 'UPDATEKAPPENTORE':
            let kappe = action.ev.titel;
            let kappe_index = action.ev.index;

            copyOfState.data[copyOfState.modell_index].pfosten[0].kappe = kappe;
            copyOfState.data[copyOfState.modell_index].pfosten[0].kappe_index = kappe_index;
        return copyOfState;

        //update antrieb
        case 'UPDATEANTRIEB':
            let antrieb = action.ev;
            copyOfState.data[copyOfState.modell_index].antrieb = antrieb;
        return copyOfState;

         //update direction
         case 'UPDATEDIRECTIONTORE':
            let direction = action.ev;
            copyOfState.data[copyOfState.modell_index].direction = direction;
        return copyOfState;

         //update description
         case 'UPDATEDESCRIPTIONTORE':
            let description = action.ev;
            copyOfState.data[copyOfState.modell_index].data_description[0].description = description;
        return copyOfState;

        //select upload file
        case 'SELECTUPLOADDATATORE':
            const fileSize = action.ev.file.size;
            const bytesToMegaBytes = fileSize / (1024 ** 2);
            if (bytesToMegaBytes>5) {
                copyOfState.data[copyOfState.modell_index].data_description[0].isUploadData = false;
            } else {
                let data_file = action.ev.file;
                copyOfState.data[copyOfState.modell_index].data_description[0].file = data_file;
                copyOfState.data[copyOfState.modell_index].data_description[0].isUploadData = true;
            }
        return copyOfState;

        //update product to merkliste
        case 'UPDATEPRODUCTTOMERKLISTE':
            let update_index = action.ev;
            if (update_index) copyOfState.data[update_index].is_merkliste = !copyOfState.data[update_index].is_merkliste;
            else copyOfState.data[copyOfState.modell_index].is_merkliste = !copyOfState.data[copyOfState.modell_index].is_merkliste;
        return copyOfState;

        default:
            return copyOfState;
    }
}

export default toreReducer;
